<template>
  <div
    v-if="loading < 4"
    key="loadingData"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="dataLoaded"
    class="m-edition-billing-academies"
  >
    <div class="display-flex-row">
      <form
        action="#"
        autocomplete="off"
        class="m-form-search"
        @submit.prevent="readAcademiasLicencias()"
      >
        <span class="a-input-wrapper-row">
          <label for="nombre">
            <input
              v-model="filter.nombre_url_academia"
              type="text"
              id="nombre"
              name="nombre"
              class="a-input-primary"
              placeholder="Nombre"
            >
          </label>
        </span>

        <span class="a-input-wrapper-row">
          <label for="propietario">
            <input
              v-model="filter.email_razon_social"
              type="text"
              id="propietario"
              name="propietario"
              class="a-input-primary"
              placeholder="Propietario"
            >
          </label>
        </span>

        <span class="a-input-wrapper-row">
          <label for="pais">
            <select
              v-model="filter.pais"
              id="pais"
              name="pais"
              class="a-input-primary"
            >
              <option value="0" disabled selected>País</option>
              <option
                v-for="pais in paises"
                :key="pais.id_pais"
                :value="pais.id_pais"
              >
                {{ pais.nombre }}
              </option>
            </select>
          </label>
        </span>

        <span class="a-input-wrapper-row">
          <label for="licencia">
            <select
              v-model="filter.producto"
              id="licencia"
              name="licencia"
              class="a-input-primary"
            >
              <option value="" disabled selected>Licencia</option>
              <option
                v-for="prod in productosVidroop"
                :key="prod.id"
                :value="prod.id"
              >
                {{ prod.nombre }}
              </option>
            </select>
          </label>
        </span>

        <span class="a-input-wrapper-row">
          <label for="estado">
            <select
              v-model="filter.estado"
              id="estado"
              name="estado"
              class="a-input-primary"
            >
              <option value="" selected disabled>Estado de Licencia</option>
              <option value="-1">Todas las licencias</option>
              <option value="1">Licencias Activas</option>
              <option value="0">Licencias Inactivas</option>
            </select>
          </label>
        </span>

        <button
          class="a-button-secondary a-button-billing-secondary margin-right-xsmall"
          :disabled="loadingRequest"
          type="button"
          @click.prevent="reload"
        >
          <i :class="loadingReload ? 'fas fa-spinner fa-spin' : 'fas fa-undo'"></i>
        </button>

        <button
          class="a-button-primary a-button-billing-primary"
          :disabled="loadingRequest || loadingDownload"
          type="submit"
          @click="loadingSubmit = true"
        >
          <i
            v-if="loadingSubmit"
            class="fas fa-spinner fa-spin"
          >
          </i>
          FILTRAR
        </button>
      </form>

      <form class="display-flex-row-center margin-left-auto">
        <button
          class="a-button-secondary a-button-billing-secondary"
          :disabled="loadingRequest"
          type="button"
          @click.prevent="downloadCSV"
        >
          <span
            v-if="!loadingDownload"
          >
            <i class="fas fa-arrow-to-bottom"></i> Descargar CSV
          </span>
          <i
            v-else
            class="fas fa-spinner fa-spin"
          >
          </i>
        </button>
      </form>
    </div>

    <div class="m-table-primary">
      <table>
        <tr>
          <th class="text-align-left">NOMBRE</th>
          <th class="text-align-left">CATEGORÍA</th>
          <th class="text-align-left">PROPIETARIO</th>
          <th class="text-align-center" width="11%">ALTA</th>
          <th class="text-align-center" width="13%">PAÍS</th>
          <th class="text-align-right" width="5%">ALUMNOS</th>
          <th class="text-align-center">LICENCIA</th>
          <th class="text-align-center">ESTADO</th>
          <th class="text-align-center" width="5%">DATOS</th>
          <th class="text-align-center" width="5%">TIENDA</th>
        </tr>
        <tr
          v-for="(ac, index) in academias"
          :key="index"
        >
          <td class="text-align-left">{{ ac.nombre_academia }}</td>
          <td class="text-align-left">{{ ac.nombre_categoria }}</td>
          <td class="text-align-left">{{ ac.email }}</td>
          <td class="text-align-center">{{ $moment.parseZone(ac.fecha_alta_academia).format('D MMM YYYY') }}</td>
          <td class="text-align-center">{{ ac.nombre_pais ? ac.nombre_pais : '-' }}</td>
          <td class="text-align-right">{{ ac.alumnos_activos }} <i class="far fa-users text-color-black-35"></i></td>
          <td class="text-align-center">{{ ac.nombre_producto ? ac.nombre_producto : '-' }}</td>
          <td class="text-align-center">{{ ac.estado ? 'Activa' : 'Inactiva'}}</td>
          <td class="text-align-center">
            <a
              :href="`/gestion/academias/${ac.id_academia}/datos`"
              class="a-button-no-border a-button-secondary a-button-billing-secondary a-button-icon-rounded align-items-center justify-content-center"
              target="_blank"
            >
              <i class="far fa-file-alt"></i>
            </a>
          </td>
          <td class="text-align-center">
            <a
              :href="`${tienda}/${ac.url_academia}`"
              class="a-button-no-border a-button-secondary a-button-billing-secondary a-button-icon-rounded align-items-center justify-content-center"
              target="_blank"
            >
              <i class="far fa-link"></i>
            </a>
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import configApp from '@/config'

export default {
  name: 'MoleculeEditionBillingAcademies',

  components: {
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      academiaCategorias: [],
      academias: [],
      productosVidroop: [],
      loading: 0,
      loadingAcademy: 0,
      loadingDownload: false,
      loadingReload: false,
      loadingRequest: false,
      loadingSubmit: false,

      filter: {
        email_razon_social: '',
        limite: 10,
        estado: '',
        nombre_url_academia: '',
        pagina: 1,
        pais: 0,
        producto: ''
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 0,
        totalQuantity: 0
      },

      paises: [],
      tienda: ''
    }
  },

  created () {
    this.readAcademiaCategorias()
    this.readAcademiasLicencias()
    this.readParametroPaises()
    this.readProductosVidroop()
    this.tienda = configApp.marketPlaceDomain
  },

  methods: {
    downloadCSV () {
      if (!this.loadingRequest) {
        this.loadingDownload = true
        this.loadingRequest = true
        this.$services.read('academia', 'readAcademiasLicenciasExportar')
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            const name = 'download'
            link.href = url
            link.setAttribute('download', `${name}.csv`, 'text/html; charset=UTF-8')
            document.body.appendChild(link)
            link.click()
            this.loadingRequest = false
            this.loadingDownload = false
          })
          .catch(error => {
            console.log(error)
            this.loadingRequest = false
            this.loadingDownload = false
            alert('Ha ocurrido un error de internet o en el servidor')
          })
      }
    },

    readAcademiaCategorias () {
      this.$services.read('academia', 'readAcademiaCategorias')
        .then(response => {
          this.academiaCategorias = [...response.data]
          this.loading++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readAcademiasLicencias () {
      if (!this.loadingRequest) {
        this.loadingRequest = true
        this.$services.read('academia', 'readAcademiasLicencias', {}, [], this.filter)
          .then(response => {
            this.academias = [...response.data.academias]
            this.pagination.currentQuantity = this.academias.length
            this.pagination.totalPages = response.data.pages
            this.pagination.totalQuantity = response.data.total
            this.pagination.showLoadingState = false
            this.loadingReload = false
            this.loadingRequest = false
            this.loadingSubmit = false
            this.loading++
          })
          .catch(error => {
            console.log(error)
            this.academias = []
            this.pagination.currentQuantity = 0
            this.pagination.totalPages = 0
            this.pagination.totalQuantity = 0
            this.pagination.showLoadingState = false
            this.loadingReload = false
            this.loadingRequest = false
            this.loadingSubmit = false
          })
      }
    },

    readParametroPaises () {
      this.$services.read('parametro', 'readParametroPaises')
        .then(response => {
          this.paises = response.data
          this.loading++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readProductosVidroop () {
      this.$services.read('producto', 'readProductosVidroopTodos', {}, [configApp.vidroopAcademyId])
        .then(response => {
          this.productosVidroop = response.data.filter(prod => prod.maximo_productos > 0)
          this.loading++
        })
        .catch(error => {
          console.log(error)
        })
    },

    reload () {
      this.loadingReload = true
      this.filter = {
        email_razon_social: '',
        limite: 10,
        nombre_url_academia: '',
        estado: '',
        pagina: 1,
        pais: 0,
        producto: ''
      }
      this.pagination = {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 0,
        totalQuantity: 0
      }
      this.readAcademiasLicencias()
    },

    setPaginationCurrentPage (page) {
      this.pagination.showLoadingState = true
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readAcademiasLicencias()
    },

    viewAcademy (academyId) {
      this.$router.push('/gestion/academias/' + academyId + '/datos')
    }
  }
}
</script>
